import {createRepository, Repository} from '@/repositories/Base/Repository'

class TuevsRepository extends Repository {
    endpoint = 'tuevs/exams/import?XDEBUG_SESSION_START=1'

    sendImportData(company_id, support_lab_id, data) {
        return this.post({company_id, support_lab_id, data})
    }

    getCompanies() {
        return this.$axios.get('tuevs/support/companies')
    }

    getSupportCompanies() {
        return this.$axios.get('tuevs/support/supportLabs')
    }

    getTuevsExams(params) {
        return this.$axios.get('tuevs/exams', {filter: params})
    }

    mapExamToTuevs(mapped_exam_id, tuevs_id) {
        return this.$axios.post('tuevs/support/map?XDEBUG_SESSION_START=1', {
            mapped_exam_id: mapped_exam_id,
            tuevs_id: tuevs_id
        })
    }

    updateExam(exam_id) {
        return this.$axios.post('tuevs/support/updateExam?XDEBUG_SESSION_START=1', {exam_id})
    }

}

export default new TuevsRepository()

export const create = createRepository(TuevsRepository)